exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.office-directory-page[data-v-9568f862]{height:100%}div.content[data-v-9568f862]{padding-top:58px;padding-bottom:67px;background-color:#fff;min-height:100%}.clickable-row[data-v-9568f862]{cursor:pointer}.chevron[data-v-9568f862]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
